import useFindTableById from "@/shared/hooks/useFindTableById";
import useRestaurantMapsWithTables from "@/shared/queries/restaurantMap/useRestaurantWithTables";
import { asArray } from "@/shared/utils/helpers";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import TablesMap from "../Tables/TablesMap";

const OrderModalMap = ({ order }: { order: OrderV2 }) => {
  const tableId = order.order_information.table_id;
  const { data } = useRestaurantMapsWithTables();
  const mapId = useFindTableById(tableId)?.mapId;
  const map = asArray(data)?.find((map) => map.item_id === mapId);
  return (
    <TablesMap
      background_color={map?.background_color}
      height={500}
      width={1000}
      scaleX={0.5}
      scaleY={0.5}
      highLight={tableId}
      readOnly
      tables={map?.tables ?? []}
    />
  );
};

export default OrderModalMap;
